// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AnswersMarketingButton-cls1__c9ff27fff3e31a4e51d2{/*!*/}.AnswersMarketingButton-cls2___4ab03fd6a84f0c91d70{}@media(max-width: 417px),(min-width: 769px)and (max-width: 991px){.AnswersMarketingButton-cls2___4ab03fd6a84f0c91d70{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AnswersMarketingButton-cls1__c9ff27fff3e31a4e51d2",
	"cls2": "AnswersMarketingButton-cls2___4ab03fd6a84f0c91d70 AnswersMarketingButton-cls1__c9ff27fff3e31a4e51d2"
};
export default ___CSS_LOADER_EXPORT___;
